export const environment = {
  production: false,
  PHP_API_URL: "https://tomertransport.com:8000/api/",
  NODE_API_URL: "https://tomertransport.com:4040/",
  SITE_URL: "https://uat.tomertransport.com",
  SHIP_WEBSITE_URL: "https://uat.ship.tomertransport.com",
  GOOGLE_CLIENT_ID: "712195133501-ajot1slvueetgf5g7aa9gu45e84fba1m.apps.googleusercontent.com"
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts